import React from "react";
import { useEffect } from "react";
import { CMSPath } from "../../../config/constant";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { makeSpaBooking } from "../../../action/spaBooking";
import moment from "moment";
import { closeOrderPopUp } from "../../action/hCommerce2";

 
import { scrollToTop } from "../../../JS/scrollToTop";
import { setGoHome } from "../../action/homeAction";
import { sendAnalytics } from "../../../action/homeAction";
import { popupOpenClose } from "../../../action/action";

function Event7_Summary(props) {
    const { t } = props;

    useEffect(() => {
        scrollToTop();
    }, []);

    const handleNext = async () => {
        try {
            await props.bookMyEvent();
            props.next();
        } catch (err) {
            props.closeOrderPopUp(true, err, "", true);

        }

    };


    return (
        <>

            <header className="inner-pages w-footer subpages">
                <a className="button-back" onClick={props.back}></a>
                <div className="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                </div>
            </header>
            <section class="widgets spa-listing spa-details">
                <div class="widget-header">
                    {props.currentWidgetObj.widgetHeaderImageUrl && (
                        <div class="widget-header-img">
                            <img
                                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                                alt={props.currentWidgetObj.displayName}
                            />
                        </div>
                    )}
                    <div class="widget-header-title">{t("events.summary")}</div>
                </div>

                <div class="detail-body stay-body">
                    <div class="stay-info">
                        <div class="stay-arrival">
                            <div class="heading">{t("events.date")}</div>
                            <div class="body">
                                <p>
                                    {" "}
                                    {
                                        // get only date here
                                        moment(props.preferredDateTime.date).format((props.dateFormat).toUpperCase())
                                    }


                                </p>
                            </div>
                        </div>
                        {/* <div class="stay-arrival">
                            <div class="heading">{t("spaBooking.time")}</div>
                            <div class="body">
                                <p>

                                    {
                                        //get only time here
                                        // formatMinutesToTimeFormat(props.selectedTechnicianDetails.startTime, toBool(props.timeFormat))
                                    }
                                </p>
                            </div>
                        </div> */}
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="detail-body stay-body">
                            <form>
                                <div class="form-row spa-summary">
                                    <p class="heading">{t("events.details")}</p>
                                    <label>
                                        {t("events.eventName")} <span>{props.selectedEvent.eventName}</span>
                                    </label>
                                    <label>
                                        {t("events.sub_event_name")} <span>{props.selectedInventory.inventory_name}</span>
                                    </label>
                                    <label>
                                        {t("events.venue")}{" "}
                                        <span>{props.selectedVenue.venueName}</span>
                                    </label>
                                    <label>
                                        {t("events.guestCount")}{" "}
                                        <span>{props.preferredDateTime.guestCount}</span>
                                    </label>
                                    <label>
                                        {t("events.guestComment")}{" "}
                                        <span>
                                            {props.additionalInfo.guestComment}
                                        </span>
                                    </label>
                                </div>


                                <div class="form-row price-total">
                                    <label>
                                        {t("events.price")}
                                        <span>
                                            {props.currencyCode}{" "}
                                            {props.selectedInventory.price}
                                        </span>
                                    </label>
                                </div>



                            </form>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="form-controls">
                        <button onClick={handleNext}>
                            {t("events.make_reservation")}
                        </button>
                        <button onClick={props.back}>{t("events.back")}</button>
                    </div>
                </div>
            </section>



        </>
    );
}
 
const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        serverTimeDate: state.store.home.serverTimeDate.date,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        menuColor: state.store.home.MenuColor,
        currencyCode: state.store.home.clientConfig.currencyDetails
            ? state.store.home.clientConfig.currencyDetails.code
            : ""

    }
}

const mapDispatchToProps = { setGoHome, closeOrderPopUp, sendAnalytics, popupOpenClose }

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('translations')(Event7_Summary));
